import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['threshold', 'thresholdInput'];

  toggleThresholdInput(event) {
    if (event.target.checked) {
      this.thresholdTarget.classList.remove('d-none')
    } else {
      this.thresholdTarget.classList.add('d-none')
    }
  }
}
